












































































































































































































































































































import { editFactory } from '@/main/pages';
import SmsEmailModal from '@/modules/kartoteka/smsEmailModal/SmsEmailModal.vue';
import { EMAIL_TYP_PZN } from '@/modules/kartoteka/smsEmailModal/constants';
import { Fakturace } from '@/modules/uctenky/fakturace';
import { DokladNaplnFakturaci, PlatbaTyp } from '@/modules/uctenky/fakturace/constants';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { EventBus } from '@/main/eventBus';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { apiProvider } from './api';
import { store } from './store/edit';
import { NAME, DOKLAD_TYP } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		SmsEmailModal,
		DmsPdfDialog,
	},
	data() {
		return {
			emailTypPzn: EMAIL_TYP_PZN.ARCHIV_DILNA_DOKLAD,
			savedZakaznikId: null as number | null,
			visibleSmsEmailModal: false,
			tiskDialog: {
				visible: false,
				filter: null as {} | null,
				fetchPdfProvider: null as (() => Promise<any>) | null,
			},
			customDialog: {
				visible: false,
				type: 0,
			},
			DokladNaplnFakturaci,
			sazby: [],
			dobropisVrubopisDTOs: {},
			pripravenaFakturace: {},
			reportType: 'null' as string,
		};
	},
	watch: {
		canProcess(newVal) {
			if (newVal) {
				EventBus.$emit('DisableAll', true);
			}
		},
	},
	computed: {
		dokladExists(): boolean {
			return !!this.DokladId && this.DokladId > 0;
		},
		showCastecnyDobropis(): boolean {
			return this.DokladDruh === DOKLAD_TYP.DAN_DOKLAD || this.DokladDruh === DOKLAD_TYP.DAN_PRODEJ || this.DokladDruh === DOKLAD_TYP.ZKRAC_DAN_DOKLAD;
		},
		showVrubopisCastDobropis(): boolean {
			return !!(this.canProcess && !this.isViewMode && this.showCastecnyDobropis && this.CanVrubopisCastecnyDobropis);
		},
		disableCastecnyDobropis(): boolean {
			return this.isDobropis || this.isStorno || this.isCastDobropis || this.isVrubopis;
		},
		diableDobropis(): boolean {
			if (this.IsReverseJobOrder) {
				return true;
			}
			return this.isSekundarniDD || this.isInterniFa || this.isZalohaFa || this.PlatbaPzn === PlatbaTyp.DONT_PAY;
		},
		isSekundarniDD(): boolean {
			return this.isDobropis || this.isStorno || this.isCastDobropis || this.isVrubopis;
		},
		isDobropis(): boolean {
			return (
				this.DokladDruh === DOKLAD_TYP.DOBROPIS
				|| this.DokladDruh === DOKLAD_TYP.DOBROPIS_NV
				|| this.DokladDruh === DOKLAD_TYP.DOBROPIS_OV
				|| this.DokladDruh === DOKLAD_TYP.DOBROPIS_1DD_NV
				|| this.DokladDruh === DOKLAD_TYP.DOBROPIS_1DD_OV
				|| this.DokladDruh === DOKLAD_TYP.DOBROP_1DD
			);
		},
		isStorno(): boolean {
			return this.isStornoZD || this.isStornoID;
		},
		isStornoZD(): boolean {
			return (
				this.DokladDruh === DOKLAD_TYP.STORNO_DD
				|| this.DokladDruh === DOKLAD_TYP.STAORNO_DD_NV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_DD_OV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_1DD
				|| this.DokladDruh === DOKLAD_TYP.STORNO_1DD_NV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_1DD_OV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_ZALOHY_OV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_ZALOHY_NV
				|| this.DokladDruh === DOKLAD_TYP.STORNO_ZAL
			);
		},
		isStornoID(): boolean {
			return this.DokladDruh === DOKLAD_TYP.STORNO_INT_DOK
				|| this.DokladDruh === DOKLAD_TYP.STORNO_INT_NV
				|| this.DokladDruh === 'JJ';
		},
		isRefDoc(): boolean {
			if (this.dmsSys.OrderDiscountPrp) {
				return this.DokladDruh === DOKLAD_TYP.REF_DOC;
			}
			if (this.dmsSys.GenerateQuotationPrp) {
				return this.DokladDruh === DOKLAD_TYP.QUICK_ESTIMATE
				|| this.DokladDruh === DOKLAD_TYP.SALE_QUOTE;
			}

			return false;
		},
		isCastDobropis(): boolean {
			return this.DokladDruh === DOKLAD_TYP.DD_CAST_DOBROPIS
				|| this.DokladDruh === DOKLAD_TYP.DD_CAST_DOBROPIS_OV
				|| this.DokladDruh === DOKLAD_TYP.DD_POL_DOB;
		},
		isVrubopis(): boolean {
			return this.DokladDruh === DOKLAD_TYP.DD_VRUBOPIS
				|| this.DokladDruh === DOKLAD_TYP.DD_VRUBOPIS_NV
				|| this.DokladDruh === DOKLAD_TYP.DD_VRUBOPIS_OV;
		},
		isInterniFa(): boolean {
			return this.DokladDruh === DOKLAD_TYP.INTERNI
				|| this.DokladDruh === DOKLAD_TYP.INT_DOKL_NV
				|| this.DokladDruh === 'JI';
		},
		isZalohaFa(): boolean {
			return this.DokladDruh === DOKLAD_TYP.ZALOHOVA_FAKTURA;
		},
		showOprava(): boolean {
			// TODO: Prav na tlacitko oprava a pravo na update
			return this.DokladDruh === DOKLAD_TYP.DAN_DOKLAD
				|| this.DokladDruh === DOKLAD_TYP.DAN_PRODEJ;
		},
		formattedSPWithVAT(): string | null {
			return this.CenaCelkemSDph != null ? formatDecimalValue(this.CenaCelkemSDph) : this.CenaCelkemSDph;
		},
	},
	methods: {
		loadedData() {
			this.savedZakaznikId = this.ZakaznikId;

			this.recomputeHash(); // TODO: remove, always compute hash after loadedData.
		},
		tiskKopie() {
			this.tiskDialog.filter = { dokladId: this.DokladId!, nahled: false };
			if (this.dmsSys.GenerateQuotationPrp) {
				if (this.DokladDruh === DOKLAD_TYP.SALE_QUOTE) {
					this.reportType = DOKLAD_TYP.SALE_QUOTE;
					this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.partSalesCopyReport({ dokladId: this.DokladId! }, false);
				} else if (this.DokladDruh === DOKLAD_TYP.QUICK_ESTIMATE) {
					this.reportType = DOKLAD_TYP.SALE_QUOTE;
					this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.quickEstimateCopyReport({ dokladId: this.DokladId! }, false);
				} else if (this.dmsSys.IndiaCFDPrp)	{
					this.reportType = this.DokladDruh!;
					this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.getTaxInvoiceReport({ dokladId: this.DokladId! }, false);
				} else {
					this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.tvorbaKopie({ dokladId: this.DokladId! }, false);
				}
			} else if (this.dmsSys.IndiaCFDPrp)	{
				this.reportType = this.DokladDruh!;
				this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.getTaxInvoiceReport({ dokladId: this.DokladId! }, false);
			} else {
				this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.tvorbaKopie({ dokladId: this.DokladId! }, false);
			}
			this.tiskDialog.visible = true;
		},
		tiskDobropisu() {
			openEdit(Fakturace.name, PageMode.CREATE, {
				filter: {
					dokladId: this.DokladId,
					dokladNaplnFakturaci: DokladNaplnFakturaci.DOBROPIS,
					orderType: this.ZakazkaDruh,
					CRNo: `${this.DokladPfx} ${this.DokladNr}`,
				},
			});
		},
		async vrubopisDobropis(type: DokladNaplnFakturaci) {
			this.dobropisVrubopisDTOs = (await apiProvider.getSazby(this.DokladId as number, type)).data;
			this.sazby = (this.dobropisVrubopisDTOs as any).Polozky;
			this.customDialog.type = type;
			this.customDialog.visible = true;
		},
		storno() {
			this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.tvorbaDobropisuPrima({
				dokladId: this.DokladId!, dokladNaplnFakturaci: DokladNaplnFakturaci.STORNO,
			});
			this.tiskDialog.visible = true;
		},
		printDialogClosed() {
			this.recomputeHash();
			this.refreshPreviousPage = true;
			this.$router.go(-1);
		},
		markReportAsPrint() {
			if (this.dmsSys.IndiaCFDPrp) {
				Fakturace.apiProvider.markReportAsPrint(this.ZakazkaId, this.reportType);
			}
		},
		async potvrditSlevy() {
			// TODO: TP1: validace jednotlivych radku dialogu this.$refs.desc.$refs.input.$refs.wrapper.$refs, kdzy sazba je 0 tak description required,
			// aspon jedna castka nenulova
			// kontrola min/max
			if (this.customDialog.type === DokladNaplnFakturaci.CASTECNY_DOBROPIS) {
				this.sazby.forEach((sazba: any) => {
					sazba.Castka *= -1;
				});
			}
			this.customDialog.visible = false;
			openEdit(Fakturace.name, PageMode.CREATE, {
				filter: {
					dokladId: this.DokladId,
					zakazkaId: this.ZakazkaId,
					dokladNaplnFakturaci: this.customDialog.type,
					dobropisVrubopisDTOs: this.sazby,
				},
			});
		},
		printServiceCreditMemo() {
			this.tiskDialog.filter = { dokladId: this.DokladId!, nahled: false };
			this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.serviceCreditMemoReportCopy({ dokladId: this.DokladId! }, false);
			this.tiskDialog.visible = true;
		},
		printPartsSalesCreditMemo() {
			this.reportType = DOKLAD_TYP.PARTS_SALES_CREDIT_MEMO;
			this.tiskDialog.filter = { dokladId: this.DokladId!, nahled: false };
			this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.partSalesCreditMemoReportCopy({ dokladId: this.DokladId! }, false);
			this.tiskDialog.visible = true;
		},
	},
});
